import { render } from "./Claim.vue?vue&type=template&id=88eaaecc&scoped=true"
import script from "./Claim.vue?vue&type=script&lang=js"
export * from "./Claim.vue?vue&type=script&lang=js"

import "./Claim.vue?vue&type=style&index=0&id=88eaaecc&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88eaaecc"]])

export default __exports__